<div class="example-card-seamless mb-5">
<h5 class="display-4 mb-4 font-weight-bold">{{sectionHeading}}</h5>
<ng-content></ng-content>
</div>
